"use strict";

PF.Field.Int = class Int extends PF.Field.String {
    static get options() {
        return {
            minValue: -Infinity,
            maxValue: Infinity,
            errors: {
                minValue: (c) => `Значение должно быть больше ${c.minValue}`,
                maxValue: (c) => `Значение должно быть меньше ${c.maxValue}`,
            }
        };
    }

    init() {
        super.init();
    }

    mediateDisplayValue(displayValue) {
        if (displayValue === null || displayValue === undefined) {
            return '';
        }
        displayValue = displayValue.replace(/\D/g, '');
        // displayValue = displayValue.replace(/[^\-]\D/g, '');
        // displayValue = displayValue.replace('--', '-');
        return displayValue;
    }

    calcDisplayValue(realValue) {
        if (realValue === null || realValue === undefined) {
            realValue = '';
        }
        let value = realValue + '';
        return value;
    }

    calcRealValue(displayValue) {
        let value = parseInt(displayValue);
        if (isNaN(value)) {
            value = null;
        }
        return value;
    }

    validate(silent, error) {
        let value = this.model.get(this.key, null, null);

        if (value !== null) {
            if (value < this.minValue) {
                return super.validate(silent, this.errors.minValue);
            }
            if (value > this.maxValue) {
                return super.validate(silent, this.errors.maxValue);
            }
        }
        return super.validate(silent, error);
    }

};